import ButtonSimple from '../buttons/ButtonSimple';
import ElinorForward from '../ElinorForward';

export default class OverlaySeekingAlert extends Phaser.Group {
  constructor(game, playerIcon, playerNr) {
    super(game);

    this.onClose = new Phaser.Signal();

    // background
    const bg = this.game.make.image(0, 0, 'bg_location_' + this.game.controller.location);
    this.addChild(bg);

    // elinor covering eyes
    this.elinor = new ElinorForward(this.game);
    this.elinor.x = this.game.defaultWidth / 2 - 300;
    this.elinor.y = this.game.defaultHeight;
    this.addChild(this.elinor);

    // btn
    // const playerNr = this.game.controller.twoPlayersModel.hidingPlayerId === 0 ? 2 : 1;
    const key = 'btn_icon_' + playerIcon;
    this.btn = new ButtonSimple({ game: this.game, up: key, over: key, atlas: 'ui_player_mode' });
    this.btn.x = this.game.defaultWidth / 2;
    this.btn.y = 360;
    this.addChild(this.btn);
    this.btn.onInputDown.add(this.handleTapButton, this);
    this.btn.scale.set(0);
    this.game.add.tween(this.btn.scale).to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);

    const icon = this.game.make.image(-10, 30, 'ui_player_mode', 'icon_' + playerIcon);
    icon.anchor.set(0.5, 1);
    icon.scale.set(0.8);
    this.btn.addChild(icon);

    const text = this.game.make.text(0, 5, playerNr, {
      font: '60px Elinor',
      fill: '#FFFFFF',
    });
    text.anchor.set(0.5, 0);
    this.btn.addChild(text);

    //
    const voID = this.game.device.desktop ? 'ob_05_elinor_020_click' : 'ob_05_elinor_020_tap';
    if (playerNr === 1) {
      // for player 1
      this.game.twoPlayersOnboarding.playVOs(
        ['ob_05_elinor_027', 'ob_05_elinor_028', voID],
        this.elinor
      );
    } else {
      // for player 2
      this.game.twoPlayersOnboarding.playVOs(
        ['ob_05_elinor_018', 'ob_05_elinor_019', voID],
        this.elinor
      );
    }
  }

  handleTapButton() {
    this.game.twoPlayersOnboarding.stopVO();
    this.onClose.dispatch();
  }

  destroy() {
    this.elinor = null;
    super.destroy();
  }
}
